import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ApiservicesService } from 'src/app/services/apiservices.service'; // Adjust path as needed
import { environment } from 'src/environments/environment'; // Adjust path as needed
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-mystery-subscription-success',
  templateUrl: './mystery-subscription-success.component.html',
  styleUrls: ['./mystery-subscription-success.component.scss'],
})
export class MysterySubscriptionSuccessComponent implements OnInit {
  loading = true;
  success = false;
  message = '';
  paymentDetails: any; // To store details from backend response or constructed for SetupIntent
  public baseUrl: any = environment.api_url;
  public mysteryStripeUserDetails: any = {};
  today: string = new Date().toLocaleDateString();

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private http: HttpClient,
    private apiservice: ApiservicesService,
    public cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.mysteryStripeUserDetails = this.cookieService.get('mysteryStripeUserDetails')
      ? JSON.parse(this.cookieService.get('mysteryStripeUserDetails'))
      : {};
    console.log(
      'MysterySubscriptionSuccessComponent - UserDetails from cookie:',
      this.mysteryStripeUserDetails
    );

    this.route.queryParams.subscribe((params) => {
      const paymentIntentId = params['payment_intent'];
      const setupIntentId = params['setup_intent'];
      const redirectStatus = params['redirect_status'];

      if (paymentIntentId) {
        console.log('Processing PaymentIntent:', paymentIntentId);
        this.handlePaymentIntent(paymentIntentId);
      } else if (setupIntentId) {
        console.log(
          'Processing SetupIntent:',
          setupIntentId,
          'with status:',
          redirectStatus
        );
        this.handleSetupIntent(setupIntentId, redirectStatus);
      } else {
        this.message =
          'No payment_intent or setup_intent found in query parameters.';
        this.loading = false;
        this.success = false;
      }
    });
  }

  handlePaymentIntent(paymentIntentId: string): void {
    this.http
      .get<any>(
        `${this.baseUrl}stripe/payment-complete?payment_intent=${paymentIntentId}`
      )
      .subscribe({
        next: (res) => {
          console.log('Backend response for PaymentIntent:', res);
          // Ensure res has an object_type or add it for consistency
          this.paymentDetails = { ...res, object_type: 'payment_intent' };
          this.loading = false;

          if (res.status === 'succeeded') {
            let body = {
              payment_id: res.id, // PaymentIntent ID
              payment_status: res.status,
              amount: res.amount,
              currency: res.currency,
              payment_process_details: res, // Full PaymentIntent object
              customer_id: this.mysteryStripeUserDetails.user_id,
              stripe_customer_id: this.mysteryStripeUserDetails.customer_id,
              subscription_id: this.mysteryStripeUserDetails.subscription_id,
              email: this.mysteryStripeUserDetails.email,
              transaction_type: 'payment',
            };

            this.saveTransactionAndUpdateCookie(body,true);

            this.success = true;
            this.message = 'Your payment was successful!';
          } else if (res.status === 'processing') {
            this.success = false;
            this.message = 'Payment is processing...';
          } else {
            let body = {
              payment_id: res.id, // PaymentIntent ID
              payment_status: 'failed',
              amount: res.amount,
              currency: res.currency,
              payment_process_details: res, // Full PaymentIntent object
              customer_id: this.mysteryStripeUserDetails.user_id,
              stripe_customer_id: this.mysteryStripeUserDetails.customer_id,
              subscription_id: this.mysteryStripeUserDetails.subscription_id,
              email: this.mysteryStripeUserDetails.email,
              transaction_type: 'payment',
            };

            this.saveTransactionAndUpdateCookie(body,false);

            this.success = false;
            this.message = `Payment ${res.status}.`;
          }
        },
        error: (err) => {
          console.error('Error fetching PaymentIntent details:', err);
          this.loading = false;
          this.success = false;
          this.message = 'Failed to retrieve payment details.';
        },
      });
  }

  handleSetupIntent(
    setupIntentId: string,
    redirectStatus: string | null
  ): void {
    this.loading = true;
    this.http
      .get<any>(
        `${this.baseUrl}stripe/default-setup-complete?payment_intent=${setupIntentId}`
      )
      .subscribe({
        next: (res) => {
          // Populate this.paymentDetails for the template
          this.paymentDetails = {
            ...res,
            object_type: 'setup_intent',
          };
          this.loading = false;
          if (res.status === 'succeeded') {
            let body = {
              payment_id: setupIntentId,
              payment_status: 'succeeded',
              amount: 0,
              currency: '',
              payment_process_details: res,
              customer_id: this.mysteryStripeUserDetails.user_id,
              stripe_customer_id: this.mysteryStripeUserDetails.customer_id,
              subscription_id: this.mysteryStripeUserDetails.subscription_id,
              email: this.mysteryStripeUserDetails.email,
              transaction_type: 'setup',
            };

            this.saveTransactionAndUpdateCookie(body, true);

            this.success = true;
            this.message = 'Your payment method has been saved successfully!';
          } else if (res.status === 'processing') {
            this.success = false;
            this.message = 'Saving payment method is processing...';
          } else {
            let body = {
              payment_id: setupIntentId,
              payment_status: 'failed',
              amount: 0,
              currency: '',
              payment_process_details: res,
              customer_id: this.mysteryStripeUserDetails.user_id,
              stripe_customer_id: this.mysteryStripeUserDetails.customer_id,
              subscription_id: this.mysteryStripeUserDetails.subscription_id,
              email: this.mysteryStripeUserDetails.email,
              transaction_type: 'setup',
            };

            this.saveTransactionAndUpdateCookie(body, false);
            this.success = false;
            this.message = `Saving payment method failed with status: ${res.status}`;
          }
        },
        error: (err) => {
          console.error('Error fetching SetupIntent details:', err);
          this.loading = false;
          this.success = false;
          this.message = 'Failed to retrieve setup intent details.';
        },
      });
  }

  saveTransactionAndUpdateCookie(
    transactionBody: any,
    isSuccess: boolean
  ): void {
    console.log('Body to be saved in DB:', JSON.stringify(transactionBody));
    if (
      this.mysteryStripeUserDetails.user_id !== undefined &&
      this.mysteryStripeUserDetails.user_id !== null 
    ) {
      this.apiservice
        .getHttpDataPost('stripe/mystery-school-transaction', transactionBody)
        .subscribe({
          next: (response) => {
            console.log(
              'Response from stripe/mystery-school-transaction:',
              response
            );
            if (response.status === 'success') {
              if (isSuccess) {
                console.log('Transaction saved successfully. Updating cookie.');
                let oldcookie = this.cookieService.get('login_user_details')
                  ? JSON.parse(this.cookieService.get('login_user_details'))
                  : null;

                if (!oldcookie) {
                  console.warn(
                    "Old cookie 'login_user_details' not found. Cannot update subscription status in cookie."
                  );
                  return;
                }

                const currentDate = new Date();
                const futureDate = new Date(currentDate);
                futureDate.setDate(currentDate.getDate() + 30);
                futureDate.setHours(23, 59, 59, 999);
                const futureTimestamp = futureDate.getTime();

                let newcookie = {
                  ...oldcookie,
                  userinfo: {
                    ...oldcookie.userinfo,
                    is_mystery_school: 1,
                    mystery_subscription_status: true,
                    mystery_school_status: 'subscription running',
                    mystery_subscription_id:
                      this.mysteryStripeUserDetails.subscription_id,
                    mystery_current_period_end: futureTimestamp,
                  },
                };
                console.log('New cookie to be set:', newcookie);
                this.cookieService.set(
                  'login_user_details',
                  JSON.stringify(newcookie),
                  { path: '/' }
                );
                console.log('Cookie updated.');
              }
            } else {
              console.error(
                'Failed to save transaction to DB. API response status:',
                response.status
              );
            }
          },
          error: (err) => {
            console.error(
              'Error calling stripe/mystery-school-transaction API:',
              err
            );
          },
        });
    } else {
      console.warn(
        'User ID missing in mysteryStripeUserDetails. Skipping DB transaction save.'
      );
    }
  }

  gotToDashBoard(path: any): void {
    this.cookieService.delete('mysteryStripeUserDetails', '/');
    this.router.navigateByUrl(`${path}`);
  }
}
